import { container, primaryColor } from 'assets/jss/material-kit-react.jsx';

const footerStyle = {
    block: {
        color: 'inherit',
        textTransform: 'uppercase',
        textDecoration: 'none',
        position: 'relative',
        display: 'block'
    },
    left: {
        float: 'left!important',
        display: 'block'
    },
    right: {
        margin: '0',
        float: 'right!important'
    },
    footer: {},
    a: {
        color: primaryColor,
        textDecoration: 'none',
        backgroundColor: 'transparent'
    },
    footerWhiteFont: {
        '&,&:hover,&:focus': {
            color: '#FFFFFF'
        }
    },
    container,
    list: {
        marginBottom: '0',
        padding: '0',
        marginTop: '0'
    },
    inlineBlock: {
        display: 'inline-block',
        padding: '0px',
        width: 'auto'
    },
    icon: {
        width: '18px',
        height: '18px',
        position: 'relative',
        top: '3px'
    }
};
export default footerStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/components/footerStyle.jsx